export const DEFAULT_DOCUMENT_FOLDER_SORT = Object.freeze({
    by: 'name',
    direction: 'asc'
});

const DOCUMENT_FOLDER_SORT_COLUMNS = new Set(['name', 'date', 'size', 'author']);
const DOCUMENT_FOLDER_SORT_DIRECTIONS = new Set(['asc', 'desc']);

export const normalizeDocumentFolderSort = (sort = {}) => {
    const requestedBy = String(sort?.by ?? sort?.sort_by ?? '').toLowerCase();
    const requestedDirection = String(
        sort?.direction ?? sort?.sort_direction ?? ''
    ).toLowerCase();

    return {
        by: DOCUMENT_FOLDER_SORT_COLUMNS.has(requestedBy)
            ? requestedBy
            : DEFAULT_DOCUMENT_FOLDER_SORT.by,
        direction: DOCUMENT_FOLDER_SORT_DIRECTIONS.has(requestedDirection)
            ? requestedDirection
            : DEFAULT_DOCUMENT_FOLDER_SORT.direction
    };
};

export const documentFolderSortsEqual = (left, right) => {
    const normalizedLeft = normalizeDocumentFolderSort(left);
    const normalizedRight = normalizeDocumentFolderSort(right);
    return normalizedLeft.by === normalizedRight.by
        && normalizedLeft.direction === normalizedRight.direction;
};

const SIZE_UNIT_BYTES = Object.freeze({
    b: 1,
    byte: 1,
    bytes: 1,
    kb: 1024,
    kib: 1024,
    mb: 1024 ** 2,
    mib: 1024 ** 2,
    gb: 1024 ** 3,
    gib: 1024 ** 3,
    tb: 1024 ** 4,
    tib: 1024 ** 4
});

export const parseDocumentSizeBytes = (value) => {
    if (typeof value === 'number') {
        return Number.isFinite(value) && value > 0 ? value : 0;
    }

    const normalized = String(value ?? '').trim().toLowerCase();
    if (!normalized) return 0;

    const numericOnly = Number(normalized.replace(/,/g, ''));
    if (Number.isFinite(numericOnly)) return Math.max(0, numericOnly);

    const cappedCount = normalized.match(/^([0-9][0-9,]*)\+$/);
    if (cappedCount) {
        return Math.max(0, Number(cappedCount[1].replace(/,/g, '')) || 0);
    }

    const match = normalized.match(/^([0-9]+(?:\.[0-9]+)?)\s*([kmgt]?i?b|bytes?)$/i);
    if (!match) return 0;

    const amount = Number(match[1]);
    const multiplier = SIZE_UNIT_BYTES[match[2].toLowerCase()] || 0;
    return Number.isFinite(amount) ? Math.max(0, amount * multiplier) : 0;
};

export const getDocumentItemSizeBytes = (item = {}) => parseDocumentSizeBytes(
    item?.size_bytes
    ?? item?.file?.size_bytes
    ?? item?.size
    ?? item?.file?.size
);
